<template>
	<div class="cd-add-to-cart-container" :class="{'unavailable': !product.is_available,}">
		<template v-if="product.is_available">
			<div class="cd-qty-container" v-show="product.available_qty > 1">
				<BaseThemeWebshopQty :quantity="1" :limit="product.available_qty" v-model="qty" />
				<div class="q-unit" v-if="product?.unit">{{product.unit}}</div>
				<div class="q-unit" v-else><BaseCmsLabel code="unit" /></div>
			</div>
			<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" :data="{modalData: product, shopping_cart_code: product.shopping_cart_code, quantity: qty}">
				<div class="btn btn-orange cd-btn-add noarrow" :class="{'loading': loading}" @click="onAddToCart">
					<UiLoader v-if="loading" /><BaseCmsLabel code="add_to_shopping_cart" tag="span" />
				</div>
			</BaseWebshopAddToCart>
		</template>
		<template v-else>
			<BaseCmsLabel code="price_unavailable_note" tag="div" class="cd-unavailable-note" v-if="item?.status == 3" />
			<BaseCmsLabel code="product_unavailable_note" tag="div" class="cd-unavailable-note" v-else />
		</template>
	</div>
</template>

<script setup>
	const props = defineProps({
		item: Object,
	})

	const product = computed(() => props?.item)
	const qty = ref();
</script>

<style lang="less" scoped>
	.cd-add-to-cart-container{position: relative; display: flex; width: 100%; gap: 12px; align-items: flex-start;}
	.cd-qty-container{
		position: relative; display: flex; flex-flow: column; align-items: center; width: 112px; flex-grow: 0; flex-shrink: 0;
		@media (max-width: @m){width: 95px; flex-grow: 0; flex-shrink: 0;}	
	}
	:deep(.qty-container){position: relative; display: flex; flex-flow: column; align-items: center; width: 112px; flex-grow: 0; flex-shrink: 0;}
	:deep(.qty-input){
		font-size: 12px; text-align: center; padding: 0 30px; height: 56px;
		@media (max-width: @m){height: 48px;}	
	}
	:deep(.qty-btn){
		position: absolute; top: 0; width: 28px; height: 56px; display: flex; align-items: center; cursor: pointer;
		@media (min-width: @h){
			&:hover .icon-dropdown{
				&:before, &:after{background: var(--blue);}
			}
		}
		@media (max-width: @m){height: 48px;}
	}
	:deep(.qty-btn-dec){
		left: 0; justify-content: flex-end; z-index: 1;
		.icon-dropdown:after{display: none;}	
	}
	:deep(.qty-btn-inc){right: 0; justify-content: flex-start;}
	:deep(.q-unit){position: relative; display: block; font-size: 11px; line-height: 12px; padding-top: 6px;}
	:deep(.cd-btn-add){
		width: 100%; font-size: 16px; padding: 0 20px; height: 56px;
		span{
			display: flex; align-items: center; 
			&:before{.icon-cart(); font: 24px/1 var(--fonti); color: #fff; margin-right: 12px;}
		}	
		&.loading{
			color: #fff!important;
			span:before{display: none;}
		}
		@media (max-width: @m){
			height: 48px; font-size: 14px; padding: 0 10px;
			span:before{font-size: 20px; margin: -5px 10px 0 0;}	
		}
	}
	.cd-unavailable-note{
		position: relative; display: flex; flex-flow: column; width: 100%; padding: 29px 30px 27px 96px; font-size: 14px; line-height: 22px; border-radius: 8px; background: var(--lightGray);
		&:before{.pseudo(56px,56px); background: #fff; border-radius: 50%; left: 24px; display: flex; align-items: center; justify-content: center; .icon-contact-mail(); font: 24px/1 var(--fonti); color: var(--red);}
		:deep(p){padding-bottom: 0;}
		:deep(strong){color: var(--red); font-size: 16px; line-height: 1; margin-bottom: 4px;}
		:deep(a){color: var(--blue); text-decoration: none; font-weight: 700;}
		@media (max-width: @m){
			padding: 28px 28px 28px 80px; font-size: 13px; line-height: 1.4;
			&:before{width: 52px; height: 52px; top: 20px; left: 16px; font-size: 24px;}
			:deep(strong){font-size: 16px; margin-bottom: 5px; display: block;}	
			:deep(a){display: inline-flex;}
			:deep(a[href*=tel]){padding-bottom: 5px;}
			:deep(br){line-height: 18px; display: block;}
		}
	}
</style>